import React from "react";
import { Box } from "@material-ui/core";
import { HeartIcon } from "../../icons";
import { ServiceList } from "./components/ServiceList";

export type VulnerabilitiesPanelProps = {
  priorityServices: string[];
  vulnerabilities: string[];
};

/**
 * A panel typically used as the header to a property
 * Displays a list of the applicable priority services and vulnerabilities
 * @param priorityServices - The priority services applicable
 * @param vulnerabilities - The vulnerabilities applicable
 * @param props - Further props to customise the underlying Box element
 */
export const VulnerabilitiesPanel: React.FC<VulnerabilitiesPanelProps> = ({
  priorityServices,
  vulnerabilities,
  ...props
}) => {
  const hasServices = priorityServices?.length || vulnerabilities?.length;

  return hasServices ? (
    <Box
      display="flex"
      py={1}
      px={2}
      color="primary.contrastText"
      bgcolor="#7B1FA2"
      data-testid="VulnerabilitiesList"
      {...props}
    >
      <Box display="flex" mt="1px">
        <HeartIcon width={24} height={24} fill="currentColor" />
      </Box>
      <Box ml={2}>
        <ServiceList
          list={priorityServices}
          singular={"Priority service"}
          plural={"Priority services"}
        />
        <ServiceList
          list={vulnerabilities}
          singular={"Vulnerability"}
          plural={"Vulnerabilities"}
        />
      </Box>
    </Box>
  ) : null;
};
